module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.17.48.1077afd7.jpeg";